import { RADashboardCardId } from './cards-enums'
import { ReportItem, ReportItemDisplayInfoLookup } from './report-items'

function getReportItemTotal(item: ReportItem) {
  return ReportItemDisplayInfoLookup[item]?.title ?? '(Unknown Report Item)'
}

export const CardTitleLookup: Record<RADashboardCardId, string> = {
  [RADashboardCardId.FactorLensRisk]: 'Factor Risk Decomposition (Full View)',
  [RADashboardCardId.FactorLensGridRisk]: 'Factor Decomposition',
  [RADashboardCardId.FactorWaterfallRisk]: 'Factor Waterfall',
  [RADashboardCardId.FactorBreakdownRisk]: 'Factor Breakdown',
  [RADashboardCardId.MetricsSummaryRisk]: 'Risk Metrics Summary',
  [RADashboardCardId.Point_DV01]: getReportItemTotal(ReportItem.DV01),
  [RADashboardCardId.Point_Duration]: getReportItemTotal(ReportItem.EffectiveDuration),
  [RADashboardCardId.Point_Convexity]: getReportItemTotal(ReportItem.Convexity),
  [RADashboardCardId.Point_YieldToMaturity]: getReportItemTotal(ReportItem.YieldToMaturity),
  [RADashboardCardId.Point_TrailingRisk]: 'Trailing Risk',
  [RADashboardCardId.HoldingsContributionRisk]: 'Portfolio Holdings',
  [RADashboardCardId.HoldingsTopBottom]: 'Top / Bottom Holdings',
  [RADashboardCardId.HoldingsRiskVisualization]: 'Risk Contribution Visualization',
  [RADashboardCardId.Point_SpreadDuration]: getReportItemTotal(ReportItem.SpreadDuration),
  [RADashboardCardId.Point_YearsToMaturity]: getReportItemTotal(ReportItem.YearsToMaturity),
  [RADashboardCardId.Point_YieldToWorst]: getReportItemTotal(ReportItem.YieldToWorst),
  [RADashboardCardId.Point_CouponRate]: getReportItemTotal(ReportItem.CouponRate),
  [RADashboardCardId.Point_DividendYield]: getReportItemTotal(ReportItem.DividendYield),
  [RADashboardCardId.Point_AverageLife]: getReportItemTotal(ReportItem.AverageLife),
  [RADashboardCardId.Point_Beta]: getReportItemTotal(ReportItem.Beta),
  [RADashboardCardId.Point_BookToPrice]: getReportItemTotal(ReportItem.BookToPrice),
  [RADashboardCardId.Point_BookValue]: getReportItemTotal(ReportItem.BookValue),
  [RADashboardCardId.Point_CashFlowYield]: getReportItemTotal(ReportItem.CashFlowYield),
  [RADashboardCardId.Point_CurrentYield]: getReportItemTotal(ReportItem.CurrentYield),
  [RADashboardCardId.Point_EPRatio]: getReportItemTotal(ReportItem.EPRatio),
  [RADashboardCardId.Point_EarningsPerShare]: getReportItemTotal(ReportItem.EarningsPerShare),
  [RADashboardCardId.Point_EffectiveD2]: getReportItemTotal(ReportItem.EffectiveD2),
  [RADashboardCardId.Point_EffectiveD3]: getReportItemTotal(ReportItem.EffectiveD3),
  [RADashboardCardId.Point_DurContributionPct]: getReportItemTotal(ReportItem.DurContributionPct),
  [RADashboardCardId.Point_DurContributionYrs]: getReportItemTotal(ReportItem.DurContributionYrs),
  [RADashboardCardId.Point_EffectiveSpreadDuration]: getReportItemTotal(ReportItem.EffectiveSpreadDuration),
  [RADashboardCardId.Point_SpreadDurContributionPct]: getReportItemTotal(ReportItem.SpreadDurContributionPct),
  [RADashboardCardId.Point_SpreadDurContributionYrs]: getReportItemTotal(ReportItem.SpreadDurContributionYrs),
  [RADashboardCardId.Point_GainLoss]: getReportItemTotal(ReportItem.GainLoss),
  [RADashboardCardId.Point_MacaulayDuration]: getReportItemTotal(ReportItem.MacaulayDuration),
  [RADashboardCardId.Point_MarketCap]: getReportItemTotal(ReportItem.MarketCap),
  [RADashboardCardId.Point_MarketCapLog]: getReportItemTotal(ReportItem.MarketCapLog),
  [RADashboardCardId.Point_MarketValue]: getReportItemTotal(ReportItem.MarketValue),
  [RADashboardCardId.Point_MarketValuePar]: getReportItemTotal(ReportItem.MarketValuePar),
  [RADashboardCardId.Point_ModifiedDuration]: getReportItemTotal(ReportItem.ModifiedDuration),
  [RADashboardCardId.Point_Momentum]: getReportItemTotal(ReportItem.Momentum),
  [RADashboardCardId.Point_MoodyQuality]: getReportItemTotal(ReportItem.MoodyQuality),
  [RADashboardCardId.Point_NotionalValue]: getReportItemTotal(ReportItem.NotionalValue),
  [RADashboardCardId.Point_OAS]: getReportItemTotal(ReportItem.OAS),
  [RADashboardCardId.Point_PBRatio]: getReportItemTotal(ReportItem.PBRatio),
  [RADashboardCardId.Point_PERatio]: getReportItemTotal(ReportItem.PERatio),
  [RADashboardCardId.Point_PctFaceMarketValue]: getReportItemTotal(ReportItem.PctFaceMarketValue),
  [RADashboardCardId.Point_PctMarketValue]: getReportItemTotal(ReportItem.PctMarketValue),
  [RADashboardCardId.Point_Price]: getReportItemTotal(ReportItem.Price),
  [RADashboardCardId.Point_SPQuality]: getReportItemTotal(ReportItem.SPQuality),
  [RADashboardCardId.Point_SecurityCount]: getReportItemTotal(ReportItem.SecurityCount),
  [RADashboardCardId.Point_TotalAccruedInterest]: getReportItemTotal(ReportItem.BaseTotalAccruedInterest),
  [RADashboardCardId.Point_TrailingEPS]: getReportItemTotal(ReportItem.TrailingEPS),
  [RADashboardCardId.Point_Volatility]: getReportItemTotal(ReportItem.Volatility),
  [RADashboardCardId.Point_YearsToWorst]: getReportItemTotal(ReportItem.YearsToWorst),
  // Attribution cards
  [RADashboardCardId.Return_Portfolio]: 'Portfolio Return',
  [RADashboardCardId.Return_Benchmark]: 'Benchmark Return',
  [RADashboardCardId.Return_Active]: 'Active Return',
  [RADashboardCardId.Chart_DailyReturn]: 'Daily Return',
  [RADashboardCardId.Chart_PortfolioReturn]: 'Portfolio Return Chart',
  [RADashboardCardId.Chart_BenchmarkReturn]: 'Benchmark Return Chart',
  [RADashboardCardId.Chart_ActiveReturn]: 'Active Return Chart',
  [RADashboardCardId.Chart_FactorAttribution]: 'Factor Attribution',
  [RADashboardCardId.Table_Holdings]: 'Portfolio Holdings',
  [RADashboardCardId.Table_HoldingsTopBottom]: 'Top / Bottom Contributors',
  [RADashboardCardId.Chart_HoldingsBubble]: 'Return Contribution Visualization',
  // End CardTitleLookup
}
